// import * as ActiveStorage from "@rails/activestorage";
// import LocalTime from "local-time";
import "@hotwired/turbo-rails";
// import "~/channels/index.js";
import "~/controllers/hub/onboarding/index.js";
import lottie from "lottie-web";
window.lottie = lottie;
// ActiveStorage.start();
// LocalTime.start();
